import React from 'react';
import { Box, useTheme } from '@mui/material';

import './FreedomLinearLoader.css';
import { appInsights } from '../../auth/appInsight';
import { getStringProduct } from '../../utils/utilityFunctions';

const FreedomLinearLoader = ({ marginleft, margintop }) => {
  const theme = useTheme();
  try {
    return (
      <Box
        component="span"
        className="loader"
        sx={{
          color: theme.palette.primary.onBoardTextColor,
          marginLeft: marginleft || '',
          marginTop: margintop || '',
          [theme.breakpoints.up('xll')]: {
            marginLeft: getStringProduct(1.25, marginleft) || '',
            marginTop: getStringProduct(1.25, margintop) || '',
          },
          [theme.breakpoints.up('xlll')]: {
            marginLeft: getStringProduct(1.66, marginleft) || '',
            marginTop: getStringProduct(1.66, margintop) || '',
          },
          [theme.breakpoints.up('xl4')]: {
            marginLeft: getStringProduct(2.46, marginleft) || '',
            marginTop: getStringProduct(2.46, margintop) || '',
          },
        }}
      ></Box>
    );
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
};

export default FreedomLinearLoader;
